import * as Yup from "yup";

// Reusable patterns
const emailRegex = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i;
const codePatterns = [
  /<[^>]*>/g, // HTML tags
  /\/\/.*|\/\*[\s\S]*?\*\//g, // JS comments
  /#.*|'''.*'''|""".*"""/g, // Python comments
  /SELECT.*FROM|INSERT INTO/gi, // SQL keywords
  /function\s*\w*\s*\(|=>\s*\(/, // JS function
  /[\{\}\[\];]/g, // Common code brackets
  /[{}<>]/g, // Common code brackets
];

function checkStringOnly(value) {
  return /^(?=.*[a-zA-Z])[0-9a-zA-Z\s.]+$/.test(value); // (name validation) this accept a-z, A-Z, 0-9 and whitespace and .(dot) and compulsory a-z or A-Z;
}

// Helper for code injection check
export const hasCodeInjection = (value) => codePatterns.some((pattern) => pattern.test(value));

// Custom method for detecting alphabets
const hasAlpha = (value) => /[A-Za-z]/.test(value || "");
const atleastOneAlphabet = (value) => /\p{L}/u.test(value || "");

// Common name validation schema
const nameField = Yup.string()
  .required("Name is required")
  .test("no-code", "Invalid Value", (value) => !hasCodeInjection(value))
  .test("has-alpha", "At least one alphabet character is required", (value) => hasAlpha(value))
  .test("atleastOneAlphabet", "At least one alphabet character is required", (value) => atleastOneAlphabet(value))
  .test("checkStringOnly", "Invalid Value", (value) => checkStringOnly(value))
  .max(100, "Name too long");

const messageField = Yup.string()
  .required("Message is required")
  .test("no-code", "Invalid Value", (value) => !value || !hasCodeInjection(value))
  .test("atleastOneAlphabet", "At least one alphabet character is required", (value) => !value || atleastOneAlphabet(value));

// Common email validation schema
const emailField = Yup.string().trim().required("Email is required").matches(emailRegex, "Please enter a valid email address");

// Common phone validation schema
const mobileField = Yup.string().required("Phone number is required");
const organizationField = Yup.string()
  .required("Please enter Institute Name")
  .test("has-alpha", "At least one alphabet character is required", (value) => hasAlpha(value));
const captchaField = Yup.string().required("Captcha verification failed");

// Dynamic schema factory
export const getValidationSchema = (identifypage) => {
  switch (identifypage) {
    case 1: // contact-form and elevate form
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        mobile: mobileField,
        organization: organizationField,
        // Interest: Yup.string().required("Please select interest"),
        // location: Yup.string().required("Location is required").min(2, "Location must be at least 2 characters"),
        message: messageField,
        captcha: captchaField,
      });

    case 2: // service-form
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        mobile: mobileField,
        organization: organizationField,
        message: messageField,
        captcha: captchaField,
      });

    case 3: // ebook-form
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        organization: organizationField,
        mobile: mobileField,
        captcha: captchaField,
      });

    case 4: // popup form
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        mobile: mobileField,
        organization: organizationField,
        // Interest: Yup.string().required("Please select interest"),
        // location: Yup.string().required("Location is required").min(2, "Location must be at least 2 characters"),
        captcha: captchaField,
      });

    case 5: // brochure form
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        mobile: mobileField,
        captcha: captchaField,
      });
    default: // any other
      return Yup.object().shape({
        name: nameField,
        email: emailField,
        mobile: mobileField,
        captcha: captchaField,
      });
  }
};
